import {call, put, takeLatest} from 'redux-saga/effects'
import {
  getAdminVenue,
  getListingType,
  getSetting,
  getSystemNotification,
  getTier,
  postSetting,
  getVenueTag,
  getPosVersion,
  getBepozCustomFieldsMetaGet,
  apiGetLoginSettings,
} from '../utilities/ApiManage'
import {
  APP_GET_DATA,
  GET_NOTIFICATION,
  GET_VENUES,
  GET_APP_SETTINGS,
  getAppSettingsSuccess,
  getListingTypeSuccess,
  getSystemNotificationSuccess,
  getPosVersionSuccess,
  getTierSuccess,
  getVenueSuccess,
  getTagsSuccess,
  GET_BEPOZ_CUSTOMFIELD_META,
  getBepozCustomFieldMetaSuccess,
  setSyncVoucher,
  setSyncPromotion,
  UPDATE_APP_SETTINGS,
  UPDATE_TIER_SETTINGS,
  GET_TAGS,
  GET_POS_VERSION,
  setShowGlobalIndicator,
  GET_LOGIN_SETTING,
  getLoginSettingsSuccess,
} from '../redux/actions/app'
import {toast} from 'react-toastify'
import {pos} from '../constants/constants'
import {PosType} from '../constants'

function* appGetData() {
  try {
    yield put(setSyncVoucher(true))
    yield put(setSyncPromotion(true))

    if (pos === PosType.bepoz) {
      //Get Bepoz Custom Field Meta
      const bepozCustomField = yield call(getBepozCustomFieldsMetaGet)
      if (bepozCustomField.ok) {
        yield put(
          getBepozCustomFieldMetaSuccess(
            bepozCustomField?.data?.ArrayOfCustomFieldMeta?.CustomFieldMeta.sort(
              (a, b) => +a.FieldType - +b.FieldType,
            ),
          ),
        )
      }
      if (!bepozCustomField.ok) {
        yield put(getBepozCustomFieldMetaSuccess([]))
      }
    }

    //Get Tier
    const resTier = yield call(getTier)
    if (resTier.ok) yield put(getTierSuccess(resTier.data))

    //Get system notification
    const resSystemNotification = yield call(getSystemNotification)
    if (resSystemNotification.ok) yield put(getSystemNotificationSuccess(resSystemNotification.data))

    //Get admin Venue
    const resVenue = yield call(getAdminVenue)
    if (resVenue.ok) yield put(getVenueSuccess(resVenue.data))

    //Get Tag
    const resTags = yield call(getVenueTag)
    if (resTags.ok) yield put(getTagsSuccess(resTags.data))

    //Get PosVersion
    const resVer = yield call(getPosVersion)
    if (resVer.ok) yield put(getPosVersionSuccess(resVer.data))

    //Get listing type
    const listingType = yield call(getListingType)
    if (listingType.ok) yield put(getListingTypeSuccess(listingType.data))

    //Get settings and sso version
    const settings = yield call(getSetting)
    if (settings.ok) {
      yield put(getAppSettingsSuccess(settings.data?.reduce((acc, item) => ({...acc, [item.key]: item}), {})))
    }
  } catch (e) {
    console.log(e)
  }
}

function* getVenueList() {
  try {
    const resVenue = yield call(getAdminVenue)
    if (resVenue.ok) {
      yield put(getVenueSuccess(resVenue.data))
    }
  } catch (e) {
    console.log(e)
  }
}

function* getNotificationList() {
  try {
    const res = yield call(getSystemNotification)
    if (res.ok) {
      yield put(getSystemNotificationSuccess(res.data))
    }
  } catch (e) {
    console.log(e)
  }
}

function* getTagsList() {
  try {
    const res = yield call(getVenueTag)
    if (res.ok) {
      yield put(getTagsSuccess(res.data))
    }
  } catch (e) {
    console.log(e)
  }
}

function* getVersionPos() {
  try {
    const res = yield call(getPosVersion)
    if (res.ok) {
      yield put(getPosVersionSuccess(res.data))
    }
    if (!res.ok) {
      yield put(getPosVersionSuccess(''))
    }
  } catch (e) {
    console.log(e)
  }
}

function* getSettingSaga() {
  try {
    const settings = yield call(getSetting)
    if (settings.ok) {
      yield put(getAppSettingsSuccess(settings.data?.reduce((acc, item) => ({...acc, [item.key]: item}), {})))
    }
  } catch (e) {}
}

function* updateAppSettings(action) {
  try {
    yield put(setShowGlobalIndicator(true))
    const res = yield call(postSetting, action.payload)
    if (res.ok) {
      toast('Updating setting is successful', {type: 'success'})
      yield call(getSettingSaga)
    } else {
      toast(res.message, {type: 'error'})
    }
  } catch (e) {
    console.log(e)
  } finally {
    yield put(setShowGlobalIndicator(false))
  }
}

function* getTierSaga() {
  const resTier = yield call(getTier)
  if (resTier.ok) yield put(getTierSuccess(resTier.data))
}

function* getLoginSettings() {
  const res = yield call(apiGetLoginSettings)
  if (res.ok) yield put(getLoginSettingsSuccess(res.data))
}

function* getBepozCustomFieldMetaSaga() {
  try {
    if (pos === PosType.bepoz) {
      const bepozCustomField = yield call(getBepozCustomFieldsMetaGet)
      if (bepozCustomField.ok) {
        yield put(
          getBepozCustomFieldMetaSuccess(
            bepozCustomField?.data?.ArrayOfCustomFieldMeta?.CustomFieldMeta.sort(
              (a, b) => +a.FieldType - +b.FieldType,
            ),
          ),
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
}

export default [
  takeLatest(APP_GET_DATA, appGetData),
  takeLatest(GET_NOTIFICATION, getNotificationList),
  takeLatest(GET_VENUES, getVenueList),
  takeLatest(GET_TAGS, getTagsList),
  takeLatest(GET_APP_SETTINGS, getSettingSaga),
  takeLatest(UPDATE_APP_SETTINGS, updateAppSettings),
  takeLatest(UPDATE_TIER_SETTINGS, getTierSaga),
  takeLatest(GET_POS_VERSION, getVersionPos),
  takeLatest(GET_LOGIN_SETTING, getLoginSettings),
  takeLatest(GET_BEPOZ_CUSTOMFIELD_META, getBepozCustomFieldMetaSaga),
]
